import React from 'react';
import { styles } from './styles';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';

import Section from '../../../shared/Section/Section';

function PrecourseBenefits({ benefits }) {
  const isLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isGreaterSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));

  return (
    <Section theme="default" customStyles={styles.section} withoutBg>
      <Box style={styles.strip(isLg, isGreaterSm)}>
        <Grid container spacing={isSm ? 1.5 : 5} justifyContent="space-between">
          {benefits &&
            benefits.map(({ text, type }, index) => (
              <Grid item xs={6} lg={index === 0 ? 3.8 : 2.7} key={type}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: '16px',
                  }}
                >
                  <Typography
                    variant="desktopH1"
                    color={'kit.text.h'}
                    lineHeight={1.1}
                  >
                    {type}
                  </Typography>
                  <Typography
                    style={styles.text(isSm)}
                    variant="desktopP1"
                    color={'kit.text.main'}
                  >
                    {text}
                  </Typography>
                </Box>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Section>
  );
}

export default PrecourseBenefits;
